import { LdEnvironmentType } from '@atlassian/mpac-feature-flags';
const developmentConfig = {
  feedbackCollectorApiKeys: {
    privacyAndSecurity: {
      entrypointId: 'a1b01fe7-d62a-402c-8523-0d3edd4ffede'
    },
    generalFeedback: {
      entrypointId: '382c9b92-a4ff-45d1-bd4d-237ce0f5ac9f'
    }
  },
  stargateBaseUrl: 'https://api.stg.atlassian.com',
  adminHubBaseUrl: 'https://admin.stg.atlassian.com',
  algolia: {
    applicationId: '7LVR1JKTDF',
    apiKey: 'a341f16064d5bffd0ef8ea56b8099661',
    environment: 'stg'
  },
  analytics: {
    productAnalytics: {
      env: 'dev'
    }
  },
  featureFlags: {
    apiKey: '455fa60a-debf-4a78-8ec0-7fef7a97ae70',
    environment: LdEnvironmentType.DEV
  },
  feedbackGatewayBaseUrl: 'https://marketplace.stg.internal.atlassian.com/gateway/api',
  mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
  mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
  sentry: {
    dsn: 'https://7dffd006b22a440ebf23b41ff691432e@sentry.io/1464982',
    environment: 'development'
  },
  showDevtools: true,
  metal: {
    id: '26e25bc0-12d0-41d7-a9ec-1e080b812477',
    env: 'dev'
  },
  host: 'https://emcee.dev.internal.atlassian.com',
  graphQLGatewayUrl: 'https://api.stg.atlassian.com/graphql',
  atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
  macBaseUrl: 'https://my.stg.internal.atlassian.com',
  wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
  environment: 'dev'
};
export default developmentConfig;